export enum IntegrationService {
  CONDUCTOR = "CONDUCTOR",
  APIDECK = "APIDECK",
}
